import { render, staticRenderFns } from "./ColumnSaleStatusCacau.vue?vue&type=template&id=0422e8c3"
import script from "./ColumnSaleStatusCacau.vue?vue&type=script&lang=js"
export * from "./ColumnSaleStatusCacau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports